import { RetailRateType } from '@ph-core/enums/retail-rate-type.enum';
import { ChildProducts, PlanName, ProductDescription, SurchargeOptions, Tax } from '@ph-model/response/interface';

export class ProductItem {
  dealer?: string;
  vendor?: string | null;
  productType: string = '';
  productCode: string = '';
  productCategory: string | null = null;
  productDescription: ProductDescription = { enUsProductDescription: '', frCaProductDescription: '' };
  planCode: string = '';
  planName: PlanName = { enUsPlanName: '', frCaPlanName: '' };
  planSKU: string = '';
  usageType: string | null = null;
  minTerm: string | null = null;
  maxTerm: string = '';
  isBundled: boolean = false;
  isDiscounted: boolean = false;
  termMileage: string = '';
  termInput?: string | null;
  deductible: string = '';
  disappearingDeductible: boolean = false;
  vehicleClass: string | null = null;
  financeAmountFrom: string = '';
  financeAmountTo: string = '';
  msrpTo: string | null = null;
  msrpFrom: string | null = null;
  vehicleSellingPriceFrom: string | null = null;
  vehicleSellingPriceTo: string | null = null;
  grossCapCostFrom: string | null = null;
  grossCapCostTo: string | null = null;
  dealerCost: number = 0;
  regulatedRate?: string | null;
  retailRateType: RetailRateType | null = 'NON_REG';
  retailRate: number = 0;
  surchargeOptions: SurchargeOptions = { surchargeOption: [] };
  startingInterval: string | null = null;
  formNumber: string = '';
  formDescription: string = '';
  vehicleClassing: string = '';
  coverageCode: string = '';
  coverageDescription: string = '';
  coverageOptions: { coverageOption: string[] } = { coverageOption: [] };
  minDollarAmount: string | null = null;
  maxDollarAmount: string | null = null;
  paymentType: string | null = null;
  startingIntervalName: string | null = null;
  minOdometer: string | null = null;
  maxOdometer: string | null = null;
  programType: string = '';
  planType: string | null = null;
  childProducts: ChildProducts | null = { childProduct: [] };
  taxes?: Tax | null;
  externalProductReferenceCode?: string | null;
  vehicleCondition?: string | null;
  riskType?: string;

  // retail error handler
  customerCost?: number;
  costPlaceholder?: number = 0;
  totalCost?: number;

  maxCost?: number;

  // taxes
  qstTax?: number;
  gstTax?: number;
  pstTax?: number;
  hstTax?: number;

  // for display purposes
  surchargeAdded?: boolean;
  isAddedToCart?: boolean;
  key?: string;

  // for display purposes - used for taxes
  displayCost?: number;
  customerTerm?: number;
  customerTermError?: boolean;
  errorFlag?: boolean;
  errorMessage?: string;

  showMileage?: boolean;
  showDeductible?: boolean;
  showPurchasedServiceIntervalsCount?: boolean;
  purchasedIntervalsCount?: number;
  unique?: string;

  // GM specific properties
  programAgentCode?: string;
  hideDealerCost?: boolean;

  // PowerUp flag
  isPowerUpProduct?: boolean;

  baseDealerCost?: number;
  baseRetailRate?: number;
  manualCustomerCostDelta?: number;
}
